'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var sizeClasses = {
  small: 'pypl-btn--small'
};

var colorClasses = {
  'outline-white': 'pypl-btn--outline-white',
  'outline-blue': 'pypl-btn--outline-blue',
  white: 'pypl-btn--white'
};

function generateClassNames(color, size, className) {
  return (0, _classnames2.default)('pypl-btn mpp-btn', colorClasses[color], sizeClasses[size], className);
}

function renderAnchor(properties) {
  var color = properties.color,
      size = properties.size,
      type = properties.type,
      className = properties.className,
      fpti = properties.fpti,
      rest = _objectWithoutProperties(properties, ['color', 'size', 'type', 'className', 'fpti']);

  return _react2.default.createElement(
    'a',
    _extends({}, rest, {
      className: generateClassNames(color, size, className),
      'data-pa-click': fpti,
      role: 'button'
    }),
    htmlToReactParser.parse(properties.children)
  );
}

function renderButton(properties) {
  var color = properties.color,
      size = properties.size,
      type = properties.type,
      className = properties.className,
      fpti = properties.fpti,
      rest = _objectWithoutProperties(properties, ['color', 'size', 'type', 'className', 'fpti']);

  return _react2.default.createElement(
    'button',
    _extends({}, rest, {
      className: generateClassNames(color, size, className),
      'data-pa-click': fpti,
      type: type
    }),
    properties.children
  );
}

function Button(props) {
  return props.href || props.target ? renderAnchor(props) : renderButton(props);
}

Button.propTypes = {
  href: _propTypes2.default.string,
  target: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(['button', 'reset', 'submit']),
  color: _propTypes2.default.oneOf(['blue', 'outline-white', 'outline-blue', 'white']),
  size: _propTypes2.default.oneOf(['normal', 'small']),
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

Button.defaultProps = {
  type: 'button',
  color: 'blue',
  size: 'normal'
};

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/atoms/button/jsx/Button.js
// module id = 123
// module chunks = 4